import React from 'react';

import { MyRecognitionDetail, MyRecognitions, RecognitionRecipientDetail } from '@hero/pages';

import { paths } from '../paths';

export const recognitionRoutes = [
  {
    path: paths.MY_RECOGNITIONS,
    element: <MyRecognitions />,
    state: {
      pageKey: 'RecognitionList',
      metadata: {
        title: 'My Recognitions'
      }
    }
  },
  {
    path: paths.MY_RECOGNITION_DETAIL(),
    element: <MyRecognitionDetail />,
    state: {
      pageKey: 'RecognitionDetail',
      metadata: {
        title: 'My Recognition detail'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.RECOGNITION_RECIPIENT_DETAIL(),
    element: <RecognitionRecipientDetail />,
    state: {
      pageKey: 'RecognitionDetail',
      metadata: {
        title: 'My Recognition detail'
      },
      shoppingCart: {
        enabled: false
      }
    }
  }
];
